import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { observe } from "@web/util/loading/loading";
import { route as r } from "@util/route";
import { ContactsService } from "@services/dws/contacts.service";
import { CrmOrdersService } from "@services/dws/crm-orders.service";
import { DWS } from "@interfaces/dws";
import { WSPaymentsService, wspaymentsLookupKeysForCrmOrder } from "../ws-payments.service";

@Injectable({
  providedIn: "root",
})
export class OrderPaymentResolverService implements Resolve<DWS.CrmOrder> {
  constructor(
    private crmOrdersService: CrmOrdersService,
    private wsPaymentsService: WSPaymentsService
  ) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<DWS.CrmOrder> {
    try {
      const orderId = r.access(route).param("orderId");

      if (orderId === "new" || !orderId) return Promise.resolve(null) as any;

      const order = await observe(
        this.crmOrdersService.get(orderId)
      ).toPromise();

      if (!order?.code && order?.id == null) return Promise.resolve(null) as any;

      for (const { saleEntityType, saleEntityId } of wspaymentsLookupKeysForCrmOrder(order)) {
        const payments = await this.wsPaymentsService
          .getPayments({ saleEntityType, saleEntityId })
          .toPromise();
        if (payments?.content?.length) {
          return Promise.resolve(payments.content[0]) as any;
        }
      }

      return Promise.resolve(null) as any;
    } catch (error) {
      console.error("Error in OrderPaymentResolverService:", error);
      return Promise.resolve(null) as any;
    }
  }
}
